import neural_rendering_gif from "../../../../content/posts/2022-11-25-nerf/neural-rendering.gif";
import * as React from 'react';
export default {
  neural_rendering_gif,
  React
};